<template>
    <v-container non-linear class="elevation-0" dark style="background: transparent">
        <v-alert v-if="partsOrderWarningMessage" border="left" color="blue-grey" dark dense class="mt-5" type="info">
            <!--Parts Order will not be availabe between Dec 1 and 8 Dec because of
            year end inventory reconciliation -->
            {{ partsOrderWarningMessage }}
        </v-alert>
        <div v-if="!isPartOrderPaused">
            <div class="container-bg" style="margin-top: 1%; margin: auto; max-width: 1000px">
                <v-card class="container-fg" dark>
                    <div style="display: flex; flex-direction: row">
                        <img style="width: 130px; margin-bottom: 1%" src="../../assets/logos/getac-logo.svg" />
                        <div class="text-h7 nav-font pl-3" style="margin-top: 1.3%">VIDEO PARTS ORDER</div>
                    </div>
                    <v-divider style="margin-bottom: 1%; border-color: gray" />
                    <div>
                        <div style="display: flex; flex-direction: row">
                            <div style="display: flex; flex-direction: column">
                                <div>
                                    <v-row>
                                        <v-alert dense type="warning">
                                            Please note: any items left in the cart longer than
                                            <strong>2 days</strong> will be removed
                                        </v-alert>
                                    </v-row>
                                    <v-row>
                                        <v-btn
                                            color="primary"
                                            width="250px"
                                            elevation="0"
                                            style="margin-bottom: 25px"
                                            @click="toCart"
                                        >
                                            Checkout Cart
                                        </v-btn>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                    </div>
                    <v-divider style="margin-bottom: 1%; border-color: gray" />
                    <div>
                        <h5 class="white--text mb-2">Input Serial Number</h5>
                    </div>
                    <v-text-field
                        v-model="serialValue"
                        label="Input Serial #"
                        class="serial-validator pr-4"
                        outlined
                        @input="getSNParts"
                    />

                    <p style="color: orange">{{ partCounter }}</p>
                    <v-divider style="margin-bottom: 1%; border-color: gray" />
                    <v-container class="pa-0" fluid grid-list-lg>
                        <v-row v-if="partsList.length > 0">
                            <v-col v-for="(item, index) in partsList" :key="index" cols="4">
                                <div class="product-card-bg">
                                    <div class="product-card">
                                        <div style="display: flex; flex-direction: row">
                                            <v-img
                                                class="parts-image"
                                                :src="`https://rma.getac.com/MSS/downloadFileAction.do?REFERENCE_ID=PN_PHOTO_${
                                                    item.imgUrl || item.pn
                                                }`"
                                            ></v-img>
                                            <div style="display: flex; flex-direction: column">
                                                <h4
                                                    style="color: white; font-weight: 400"
                                                    class="text-h7 nav-font mb-3"
                                                >
                                                    {{ item.partSpec }}</h4
                                                >
                                                <v-btn
                                                    color="primary"
                                                    small
                                                    dark
                                                    elevation="0"
                                                    outlined
                                                    style="margin-bottom: 20px; max-width: fit-content"
                                                    :disabled="reachedMaxAmt"
                                                    @click="add2Cart(item)"
                                                    >Add to Cart</v-btn
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <v-divider style="margin-bottom: 1%; border-color: rgb(56, 56, 56); width: 90%" />
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </div>
            <v-snackbar v-model="snackbar">
                <div v-html="snackbarMessage"></div>

                <template v-slot:action="{ attrs }">
                    <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
                </template>
            </v-snackbar>
        </div>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import gql from 'graphql-tag'

export default {
    name: 'VideoPartsOrderStepper',
    data() {
        return {
            serialValue: '',
            partsOrderWarningMessage: '',
            isPartOrderPaused: false,
            selectedModel: null,
            partsList: [],
            partCounter: '',
            reachedMaxAmt: false,
            snackbar: false,
            snackbarMessage: ''
        }
    },
    computed: {
        ...mapGetters({
            cart: `videoCart/cart`
        })
    },
    methods: {
        ...mapActions({
            add: `videoCart/add`
        }),
        add2Cart(selectedItem) {
            if (!this.serialValue) {
                this.snackbar = true
                this.snackbarMessage = 'Please input serial'
            } else {
                const selectedSerial = selectedItem.serial
                const currentCart = this.cart.map((item) => ({
                    pn: item.pn,
                    category: item.category,
                    serial: item.serials
                }))
                let serialCount = 0
                currentCart.forEach((element) => {
                    if (selectedSerial === element.serial) {
                        serialCount++
                    }
                })
                if (serialCount < 2) {
                    this.add({
                        ...selectedItem,
                        // pn: selectedItem.pn,
                        serials: selectedSerial
                    })
                    this.snackbar = true
                    this.snackbarMessage = selectedItem.partSpec + ' has been added to your cart.'
                } else {
                    this.partCounter = 'Maximum number of parts for this item has been reached. (Max: 2)'
                    this.reachedMaxAmt = true
                    this.snackbar = true
                    this.snackbarMessage = 'Failed to add: Maximum part quantity per serial exceeded'
                }
            }
        },
        toCart() {
            this.$router.push({ path: '/video-parts-order/cart' })
        },
        getSNParts() {
            const serial = this.serialValue
            if (!serial) return
            this.partsList = []
            this.reachedMaxAmt = false
            this.partCounter = ''
            this.$apollo
                .query({
                    query: gql`
                        query QueryVideoSMConfig($sn: String!) {
                            queryVideoSMConfig(sn: $sn) {
                                category
                                partSpec
                                pn
                                imgUrl
                            }
                        }
                    `,
                    variables: {
                        sn: serial
                    }
                })
                .then((data) => {
                    if (data.errors) {
                        this.snackbar = true
                        this.snackbarMessage = data.errors[0].message
                    } else {
                        const partsList = data.data.queryVideoSMConfig
                        this.partsList = partsList.map((item) => {
                            return { ...item, serial: serial }
                        })
                        if(!partsList.length) {
                            this.snackbar = true
                            this.snackbarMessage = `No Parts found for serial: ${serial}.`
                        }
                    }
                })
                .catch((ex) => {
                    this.snackbar = true
                    this.snackbarMessage = ex.message
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
#parts-select {
    margin-right: 100px;
}
.parts-image {
    margin-bottom: 5%;
    margin-right: 12px;
    max-width: 95px;
    height: auto;
    /* max-width: 75px; */
}
.product-card {
    margin: auto;
    margin-bottom: 10px;
    text-transform: uppercase;
    border-right: 1px solid rgb(56, 56, 56);
}
.serial-validator {
    text-transform: uppercase;
}
</style>
